import {useNavigate} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';
import {
    Alert,
    Button,
    List,
    Stack,
    Title
} from '@mantine/core';
import {AiOutlineHome} from 'react-icons/ai';

export const AuthTimeoutPage = () => {
    const navigate = useNavigate();

    return (
        <Stack gap="xl" align="center" style={{maxWidth: 600, margin: 'auto'}}>
            <Title order={2}>{I18n.get('Authentication Timed Out')}</Title>

            <Alert color="orange" title={I18n.get('What happened?')}>
                {I18n.get('The sign-in process is taking longer than expected. This can happen when:')}
                <List mt="sm" size="sm">
                    <List.Item>{I18n.get('Your account has not completed the onboarding process')}</List.Item>
                    <List.Item>{I18n.get('The identity provider did not respond in time')}</List.Item>
                    <List.Item>{I18n.get('There was a network interruption during authentication')}</List.Item>
                </List>
            </Alert>

            <Alert color="blue" title={I18n.get('What to do next')}>
                <List size="sm">
                    <List.Item>{I18n.get('If you have not completed onboarding, please use the onboarding invitation link sent to your email')}</List.Item>
                    <List.Item>{I18n.get('If you have already onboarded, try signing in again')}</List.Item>
                    <List.Item>{I18n.get('If the problem persists, contact your administrator')}</List.Item>
                </List>
            </Alert>

            <Button
                onClick={() => navigate('/')}
                leftSection={<AiOutlineHome/>}
                size="md"
            >
                {I18n.get('Start Over')}
            </Button>
        </Stack>
    );
};
